import { findParentCollection } from '../collectionTraits/utils';

export default function (editor, opt = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { collections } = opt || {};

  domc.addType('pagination', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          tagName: 'div',
          icon: '<i class="wb webconnect-subtract"></i>',
          draggable: '.data-table,.data-group', // Can be dropped only inside `form` elements
          droppable: true, // Can't drop other elements inside
          isDrop: false,
          traits: [
            {
              type: 'select',
              label: 'Data Source',
              name: 'data-datasource',
              default: 'DEFAULT',
              options: [
                { value: 'DEFAULT', name: 'Default' },
                { value: 'SUPABASE', name: 'Supabase' },
                { value: 'DIRECTUS', name: 'Directus' },
                { value: 'MYSQL', name: 'MySQL' },
              ],
            },
            {
              type: 'text',
              label: 'Record Offset Key',
              name: 'data-offset-key',
              value: '',
              placeholder: 'eg. offset',
            },
            {
              type: 'text',
              label: 'Page Offset Key',
              name: 'data-page-offset-key',
              value: '',
              placeholder: 'eg. page',
            },
            {
              type: 'text',
              label: 'Records Per Page Key',
              name: 'data-limit-key',
              value: '',
              placeholder: 'eg. limit',
            },
            {
              type: 'checkbox',
              label: 'Persist Pagination on Page Reload',
              name: 'data-persistPagination',
              default: false,
            },
            {
              type: 'checkbox',
              label: 'Initially Hidden',
              name: 'data-hidden',
              default: false,
            },
            ...domc.getType('table').model.prototype.defaults.traits,
          ],
        },
        init() {
          if (!this.get('isDrop')) {
            this.handleDataSource();
            this.set('isDrop', true);
          }
        },
        handleDataSource() {
          const collectionName = findParentCollection(this, opt);
          if (collectionName && collections) {
            const selectedCollection = collections.find(
              (collection) => collection.collectionName === collectionName,
            );
            if (selectedCollection) {
              const { sourceOfOrigin } = selectedCollection;
              if (sourceOfOrigin) {
                this.set('data-datasource', sourceOfOrigin);
                const attrs = this.getAttributes();
                attrs['data-datasource'] = sourceOfOrigin;
                this.setAttributes(attrs);
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'pagination') {
            return {
              type: 'pagination',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init() {},
    }),
  });
}
